import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Spacer, Stack } from '@emburse/embark-core';
import { $t, useTranslation } from '../../../hooks/useTranslation';
function ERPGatewayNoConfiguration({ onConfigure, configText }) {
    useTranslation();
    return (_jsxs(Stack, { spacing: 2, alignItems: "flex-start", children: [configText, _jsx(Spacer, { size: 10 }), _jsx(Button, { onClick: onConfigure, children: $t('Configure') })] }));
}
export default ERPGatewayNoConfiguration;
